// しんかのきせき対象（最終進化前）ポケモン名リスト
export const NOT_LAST_EVOLVE_POKEMON_NAMES = new Set([
  'フシギダネ',
  'フシギソウ',
  'ヒトカゲ',
  'リザード',
  'ゼニガメ',
  'カメール',
  'キャタピー',
  'トランセル',
  'ビードル',
  'コクーン',
  'ポッポ',
  'ピジョン',
  'コラッタ',
  'オニスズメ',
  'アーボ',
  'ピカチュウ',
  'サンド',
  'ニドラン♀',
  'ニドリーナ',
  'ニドラン♂',
  'ニドリーノ',
  'ピッピ',
  'ロコン',
  'プリン',
  'ズバット',
  'ゴルバット',
  'ナゾノクサ',
  'クサイハナ',
  'パラス',
  'コンパン',
  'ディグダ',
  'ニャース',
  'コダック',
  'マンキー',
  'オコリザル',
  'ガーディ',
  'ニョロモ',
  'ニョロゾ',
  'ケーシィ',
  'ユンゲラー',
  'ワンリキー',
  'ゴーリキー',
  'マダツボミ',
  'ウツドン',
  'メノクラゲ',
  'イシツブテ',
  'ゴローン',
  'ポニータ',
  'ヤドン',
  'コイル',
  'レアコイル',
  'ドードー',
  'パウワウ',
  'ベトベター',
  'シェルダー',
  'ゴース',
  'ゴースト',
  'イワーク',
  'スリープ',
  'クラブ',
  'ビリリダマ',
  'タマタマ',
  'カラカラ',
  'ベロリンガ',
  'ドガース',
  'サイホーン',
  'サイドン',
  'ラッキー',
  'モンジャラ',
  'タッツー',
  'シードラ',
  'トサキント',
  'ヒトデマン',
  'ストライク',
  'エレブー',
  'ブーバー',
  'コイキング',
  'イーブイ',
  'ポリゴン',
  'オムナイト',
  'カブト',
  'ミニリュウ',
  'ハクリュー',
  'チコリータ',
  'ベイリーフ',
  'ヒノアラシ',
  'マグマラシ',
  'ワニノコ',
  'アリゲイツ',
  'オタチ',
  'ホーホー',
  'レディバ',
  'イトマル',
  'チョンチー',
  'ピチュー',
  'ピィ',
  'ププリン',
  'トゲピー',
  'トゲチック',
  'ネイティ',
  'メリープ',
  'モココ',
  'マリル',
  'ハネッコ',
  'ポポッコ',
  'エイパム',
  'ヒマナッツ',
  'ヤンヤンマ',
  'ウパー',
  'ヤミカラス',
  'ムウマ',
  'キリンリキ',
  'クヌギダマ',
  'ノコッチ',
  'グライガー',
  'ブルー',
  'ニューラ',
  'ヒメグマ',
  'リングマ',
  'マグマッグ',
  'ウリムー',
  'イノムー',
  'テッポウオ',
  'デルビル',
  'ゴマゾウ',
  'ポリゴン２',
  'オドシシ',
  'バルキー',
  'ムチュール',
  'エレキッド',
  'ブビィ',
  'ヨーギラス',
  'サナギラス',
  'キモリ',
  'ジュプトル',
  'アチャモ',
  'ワカシャモ',
  'ミズゴロウ',
  'ヌマクロー',
  'ポチエナ',
  'ジグザグマ',
  'マッスグマ',
  'ケムッソ',
  'カラサリス',
  'マユルド',
  'ハスボー',
  'ハスブレロ',
  'タネボー',
  'コノハナ',
  'スバメ',
  'キャモメ',
  'ラルトス',
  'キルリア',
  'アメタマ',
  'キノココ',
  'ナマケロ',
  'ヤルキモノ',
  'ツチニン',
  'ゴニョニョ',
  'ドゴーム',
  'マクノシタ',
  'ルリリ',
  'ノズパス',
  'エネコ',
  'ココドラ',
  'コドラ',
  'アサナン',
  'ラクライ',
  'ロゼリア',
  'ゴクリン',
  'キバニア',
  'ホエルコ',
  'ドンメル',
  'バネブー',
  'ナックラー',
  'ビブラーバ',
  'サボネア',
  'チルット',
  'ドジョッチ',
  'ヘイガニ',
  'ヤジロン',
  'リリーラ',
  'アノプス',
  'ヒンバス',
  'カゲボウズ',
  'ヨマワル',
  'サマヨール',
  'ソーナノ',
  'ユキワラシ',
  'タマザラシ',
  'トドグラー',
  'パールル',
  'タツベイ',
  'コモルー',
  'ダンバル',
  'メタング',
  'ナエトル',
  'ハヤシガメ',
  'ヒコザル',
  'モウカザル',
  'ポッチャマ',
  'ポッタイシ',
  'ムックル',
  'ムクバード',
  'ビッパ',
  'コロボーシ',
  'コリンク',
  'ルクシオ',
  'スボミー',
  'ズガイドス',
  'タテトプス',
  'ミノムッチ(くさきのミノ)',
  'ミツハニー',
  'ブイゼル',
  'チェリンボ',
  'カラナクシ(にしのうみ)',
  'フワンテ',
  'ミミロル',
  'ニャルマー',
  'リーシャン',
  'スカンプー',
  'ドーミラー',
  'ウソハチ',
  'マネネ',
  'ピンプク',
  'フカマル',
  'ガバイト',
  'ゴンベ',
  'リオル',
  'ヒポポタス',
  'スコルピ',
  'グレッグル',
  'ケイコウオ',
  'タマンタ',
  'ユキカブリ',
  'フィオネ',
  'ツタージャ',
  'ジャノビー',
  'ポカブ',
  'チャオブー',
  'ミジュマル',
  'フタチマル',
  'ミネズミ',
  'ヨーテリー',
  'ハーデリア',
  'チョロネコ',
  'ヤナップ',
  'バオップ',
  'ヒヤップ',
  'ムンナ',
  'マメパト',
  'ハトーボー',
  'シママ',
  'ダンゴロ',
  'ガントル',
  'コロモリ',
  'モグリュー',
  'ドッコラー',
  'ドテッコツ',
  'オタマロ',
  'ガマガル',
  'クルミル',
  'クルマユ',
  'フシデ',
  'ホイーガ',
  'モンメン',
  'チュリネ',
  'バスラオ(あかすじのすがた)',
  'メグロコ',
  'ワルビル',
  'ダルマッカ',
  'イシズマイ',
  'ズルッグ',
  'デスマス',
  'プロトーガ',
  'アーケン',
  'ヤブクロン',
  'ゾロア',
  'チラーミィ',
  'ゴチム',
  'ゴチミル',
  'ユニラン',
  'ダブラン',
  'コアルヒー',
  'バニプッチ',
  'バニリッチ',
  'シキジカ(はるのすがた)',
  'カブルモ',
  'タマゲタケ',
  'プルリル',
  'バチュル',
  'テッシード',
  'ギアル',
  'ギギアル',
  'シビシラス',
  'シビビール',
  'リグレー',
  'ヒトモシ',
  'ランプラー',
  'キバゴ',
  'オノンド',
  'クマシュン',
  'チョボマキ',
  'コジョフー',
  'ゴビット',
  'コマタナ',
  'キリキザン',
  'ワシボン',
  'バルチャイ',
  'モノズ',
  'ジヘッド',
  'メラルバ',
  'ハリマロン',
  'ハリボーグ',
  'フォッコ',
  'テールナー',
  'ケロマツ',
  'ゲコガシラ',
  'ホルビー',
  'ヤヤコマ',
  'ヒノヤコマ',
  'コフキムシ',
  'コフーライ',
  'シシコ',
  'フラベベ(あかいはな)',
  'フラエッテ(あかいはな)',
  'メェークル',
  'ヤンチャム',
  'ニャスパー',
  'ヒトツキ',
  'ニダンギル',
  'シュシュプ',
  'ペロッパフ',
  'マーイーカ',
  'カメテテ',
  'クズモー',
  'ウデッポウ',
  'エリキテル',
  'チゴラス',
  'アマルス',
  'ヌメラ',
  'ヌメイル',
  'ボクレー',
  'バケッチャ(ふつうのサイズ)',
  'カチコール',
  'オンバット',
  'モクロー',
  'フクスロー',
  'ニャビー',
  'ニャヒート',
  'アシマリ',
  'オシャマリ',
  'ツツケラ',
  'ケララッパ',
  'ヤングース',
  'アゴジムシ',
  'デンヂムシ',
  'マケンカニ',
  'アブリー',
  'イワンコ',
  'ヒドイデ',
  'ドロバンコ',
  'シズクモ',
  'カリキリ',
  'ネマシュ',
  'ヤトウモリ',
  'ヌイコグマ',
  'アマカジ',
  'アママイコ',
  'コソクムシ',
  'スナバァ',
  'タイプ：ヌル',
  'ジャラコ',
  'ジャランゴ',
  'コスモッグ',
  'コスモウム',
  'ベベノム',
  'サルノリ',
  'バチンキー',
  'ヒバニー',
  'ラビフット',
  'メッソン',
  'ジメレオン',
  'ホシガリス',
  'ココガラ',
  'アオガラス',
  'サッチムシ',
  'レドームシ',
  'クスネ',
  'ヒメンカ',
  'ウールー',
  'カムカメ',
  'ワンパチ',
  'タンドン',
  'トロッゴン',
  'カジッチュ',
  'スナヘビ',
  'サシカマス',
  'エレズン',
  'ヤクデ',
  'タタッコ',
  'ヤバチャ(がんさくフォルム)',
  'ミブリム',
  'テブリム',
  'ベロバー',
  'ギモー',
  'マホミル',
  'ユキハミ',
  'ゾウドウ',
  'ジュラルドン',
  'ドラメシヤ',
  'ドロンチ',
  'ダクマ',
  'ニャオハ',
  'ニャローテ',
  'ホゲータ',
  'アチゲータ',
  'クワッス',
  'ウェルカモ',
  'グルトン',
  'タマンチュラ',
  'マメバッタ',
  'パモ',
  'パモット',
  'ワッカネズミ',
  'パピモッチ',
  'ミニーブ',
  'オリーニョ',
  'コジオ',
  'ジオヅム',
  'カルボウ',
  'ズピカ',
  'カイデン',
  'オラチフ',
  'シルシュルー',
  'アノクサ',
  'ノノクラゲ',
  'カプサイジ',
  'シガロコ',
  'ヒラヒナ',
  'カヌチャン',
  'ナカヌチャン',
  'ウミディグダ',
  'ナミイルカ',
  'ブロロン',
  'キラーメ',
  'ボチ',
  'アルクジラ',
  'セビエ',
  'セゴール',
  'コレクレー(はこフォルム)',
  'カミッチュ',
  'チャデス(マガイモノのすがた)',
  'カモネギ(ガラルのすがた)',
  'バリヤード(ガラルのすがた)',
  'サニーゴ(ガラルのすがた)',
  'ハリーセン(ヒスイのすがた)',
]);
